import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

export default function ResetPasswordPage() {
  const [search] = useSearchParams();
  const token = search.get("token");
  const [newPassword, setNewPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (newPassword.length < 6) { toast.error("Password minimal 6 karakter"); return; }
    if (newPassword !== confirm) { toast.error("Konfirmasi password tidak cocok"); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: newPassword });
      setDone(true); toast.success("Password berhasil direset");
    } catch(err) { toast.error(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  if (!token) return <div className="min-h-screen flex items-center justify-center text-slate-500">Tautan tidak valid.</div>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 p-4">
      <div className="bg-white rounded-lg shadow-md p-8 w-full max-w-md">
        <div className="flex items-center gap-3 mb-6">
          <img src="/logo-gema.png" alt="GEMA" className="w-12 h-12 rounded-xl object-cover"/>
          <div>
            <div className="font-heading font-bold text-slate-900">GEMA ERP</div>
            <div className="text-xs text-[#4C1D95] tracking-widest uppercase font-semibold">Reset Password</div>
          </div>
        </div>
        {done ? (
          <div className="text-center space-y-3">
            <div className="text-green-600 font-semibold">✓ Password berhasil diubah</div>
            <button onClick={()=>nav("/login")} className="w-full py-2 bg-[#00558F] hover:bg-[#003E6B] text-white rounded-md">Kembali ke Login</button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="text-sm font-semibold text-slate-700 block mb-1">Password Baru</label>
              <input data-testid="new-password" type="password" required minLength={6} value={newPassword} onChange={e=>setNewPassword(e.target.value)} className="w-full px-4 py-2 border border-slate-300 rounded-md"/>
            </div>
            <div>
              <label className="text-sm font-semibold text-slate-700 block mb-1">Konfirmasi Password</label>
              <input data-testid="confirm-password" type="password" required minLength={6} value={confirm} onChange={e=>setConfirm(e.target.value)} className="w-full px-4 py-2 border border-slate-300 rounded-md"/>
            </div>
            <button data-testid="reset-submit" type="submit" disabled={loading} className="w-full py-2 bg-[#00558F] hover:bg-[#003E6B] text-white rounded-md font-semibold disabled:opacity-60">{loading?"Menyimpan...":"Simpan Password Baru"}</button>
          </form>
        )}
      </div>
    </div>
  );
}
